export var DAY_FORMAT = "MMM D, YYYY";
export var TIME_FORMAT = "h:mm A";
//# sourceMappingURL=constants.js.map